import { RockPaperScissorsChoice } from '~/shared';
import { createSlice } from '../wrappers';

const initialState = {
	playerChoice: null as RockPaperScissorsChoice | null,
};

const rockPaperScissorsSlice = createSlice({
	name: 'rockPaperScissors',
	initialState,
	reducers: {
		setPlayerChoice: (state, action) => {
			state.playerChoice = action.payload;
		},
	},
});

export const { setPlayerChoice } = rockPaperScissorsSlice.actions;

export default rockPaperScissorsSlice.reducer;
